export default function getDomainSuffix(): string {
  return (
    import.meta.env.VITE_LOCAL_DOMAIN_SUFFIX ||
    (typeof window !== "undefined"
      ? window.location.hostname
          .split(".")
          .slice(1)
          .filter(part => part !== "beta")
          .join(".")
      : "") ||
    "development.neonumy.dev"
  );
}
